module.exports = __webpack_public_path__ + "img/coffee.ed47a91c.png";